// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { DefaultSubscriptions } from '../../../../types/server/modules/default/subscriptions';

export type * from '../../../../types/server/modules/default/subscriptions';

export const createSubscriptions = ( requests: Requests ): DefaultSubscriptions => ({
  BillingProfiles: ( params, onChange ) => {
          return requests.subscribe( `/billing/profiles/:id?`, params, 'BillingProfiles', onChange );
          },
  BillingAccounts: ( params, onChange ) => {
          return requests.subscribe( `/billing/accounts/:id?`, params, 'BillingAccounts', onChange );
          },
  BillingContracts: ( params, onChange ) => {
          return requests.subscribe( `/billing/contracts/:id?`, params, 'BillingContracts', onChange );
          },
  BillingSubscriptionInvoices: ( params, onChange ) => {
          return requests.subscribe( `/billing/subscriptionInvoices/:id?`, params, 'BillingSubscriptionInvoices', onChange );
          },
  BillingPayments: ( params, onChange ) => {
          return requests.subscribe( `/billing/payments/:id?`, params, 'BillingPayments', onChange );
          },
  BillingCredits: ( params, onChange ) => {
          return requests.subscribe( `/billing/credits/:id?`, params, 'BillingCredits', onChange );
          },
  BillingDebits: ( params, onChange ) => {
          return requests.subscribe( `/billing/debits/:id?`, params, 'BillingDebits', onChange );
          },
  BillingBalances: ( params, onChange ) => {
          return requests.subscribe( `/billing/balances/:id?`, params, 'BillingBalances', onChange );
          },
  BillingGatewayOrphans: ( params, onChange ) => {
          return requests.subscribe( `/billing/gateway/orphans/:id?`, params, 'BillingGatewayOrphans', onChange );
          },
  BillingDunningProcesses: ( params, onChange ) => {
          return requests.subscribe( `/billing/dunning-processes/:id?`, params, 'BillingDunningProcesses', onChange );
          }
});
